import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { replace, useFormik } from "formik";
import { setPassvalidateSchema } from "../utils/Validations";
import { postRequest } from "../services/apiMethods";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";




export default function SetPassword() {
    const Navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const data = useLocation();

    const id = data?.search.split('?')[1] || '';

    const { mutate, isLoading: apiState } = useMutation({
        mutationFn: (data) => {
            const modifyData = {
                password: data?.newpassword || "",
                id: id
            }
            return postRequest(`/auth/set-password`, modifyData);
        },
        onSuccess: (data) => {
            toast.success(`${data?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            localStorage.setItem("isPasswordSet", "true");
              Navigate("/", { replace: true });
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });

    const formik = useFormik({
        initialValues: {
            newpassword: '',
            confirmedpassword: ""
        },
        validationSchema: setPassvalidateSchema,
        onSubmit: async (values) => {
            if (values) {
                mutate(values)

            }

        }
    })

    return (

        <div className="cmn-gradient">
            <div className="sign-shape">
                <Container fluid>
                    <Row className="justify-content-center main-custom-box ">
                        <Col xxl={5} xl={5} lg={6} className="">
                            {" "}
                            <div className="cmn-card-color pb-4 pt-4">
                                <div className="student-view">
                                    <h2>Set your password</h2>
                                    <Form onSubmit={formik.handleSubmit} >

                                        <Form.Group className="mb-3 custom-input-box" controlId="formBasicPassword">
                                            <Form.Label>New Password</Form.Label>
                                            <Form.Control type="password"
                                                placeholder="Type Here"
                                                name="newpassword"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.newpassword}
                                            />
                                            {formik.submitCount > 0 && formik.errors.newpassword && (
                                                <div className="error text-danger">{formik.errors.newpassword}</div>
                                            )}
                                        </Form.Group>
                                        <Form.Group className="mb-3 custom-input-box" controlId="formBasicPassword">
                                            <Form.Label>Re Type New Password</Form.Label>
                                            <Form.Control type="password"
                                                placeholder="Type Here"
                                                name="confirmedpassword"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.confirmedpassword}
                                            />
                                            {formik.submitCount > 0 && formik.errors.confirmedpassword && (
                                                <div className="error text-danger">{formik.errors.confirmedpassword}</div>
                                            )}
                                        </Form.Group>

                                        <button type="submit" className="cmn-pink w-100 mb-3 mt-4" disabled={isLoading ? true : false}>
                                            {isLoading ? "loading..." : "Update Password"}
                                        </button>
                                    </Form>

                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    );
}


